<template>
  <div class="InstitutionAppointmentSchedule">
    <s-card>
      <header>
        <s-heading>Marque sua consulta online</s-heading>
      </header>

      <body>
        <form>
          <form-select
            v-model="selectedUnit"
            class="mb-4"
            label="Unidade de atendimento"
            :options="unitsOptions"
          />
          <form-select
            v-model="selectedUnitSpecialty"
            label="Especialidade ou Exame"
            :options="unitSpecialtiesOptions"
            :disabled="!unitSpecialtiesOptions.length"
          />
        </form>
      </body>

      <s-doctor-select v-if="!selectedDoctor.name">
        <span>Escolha o profissional de saúde</span>
        <app-button
          variant="light"
          size="sm"
          pill
          @click.native="openDoctorsModal"
          :disabled="isDoctorSelectButtonDisabled"
        >
          <custom-icons
            class="mr-1"
            name="plus-icon"
            :color="iconColor"
            :width="16"
            :height="16"
          />
          Adicionar
        </app-button>
      </s-doctor-select>

      <s-selected-doctor v-else>
        <s-selected-doctor-info>
          <div>
            <h4>{{ selectedDoctor.name }}</h4>
            <span>
              {{ selectedDoctor.doctor_property.council_name }},
              {{ selectedDoctor.doctor_property.council_number }}
            </span>
          </div>

          <app-button
            variant="light"
            size="sm"
            pill
            @click.native="openDoctorsModal"
          >
            Alterar
          </app-button>
        </s-selected-doctor-info>
      </s-selected-doctor>

      <s-doctor-schedule>
        <institution-schedule-table
          v-if="selectedDoctor.id"
          :doctor="selectedDoctor"
          :unit-id="selectedUnit"
          @selectSlot="selectScheduleSlot"
        />

        <app-button
          class="mt-4"
          block
          @click.native="
            schedule(
              selectedScheduleSlot.hour,
              selectedScheduleSlot.slot_date,
              selectedScheduleSlot.slot_id
            )
          "
          :disabled="!isButtonDisabled"
        >
          Agendar Consulta
        </app-button>
      </s-doctor-schedule>
    </s-card>

    <b-modal
      id="doctorsModal"
      ref="doctorsModal"
      size="xl"
      centered
      hide-footer
      hide-header
    >
      <institution-doctors
        :unit-id="selectedUnit"
        :specialty-id="selectedUnitSpecialty"
        @closeModal="closeDoctorsModal"
        @selectDoctor="selectScheduleDoctor"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  SCard,
  SDoctorSchedule,
  SDoctorSelect,
  SHeading,
  SSelectedDoctor,
  SSelectedDoctorInfo
} from "./styles";
import FormSelect from "../../FormSelect";
import AppButton from "../../AppButton";
import CustomIcons from "../../CustomIcons.vue";
import InstitutionScheduleTable from "../InstitutionScheduleTable";
import InstitutionDoctors from "../InstitutionDoctors";

export default {
  name: "InstitutionSchedule",
  components: {
    SCard,
    SDoctorSchedule,
    SDoctorSelect,
    SHeading,
    SSelectedDoctor,
    SSelectedDoctorInfo,
    FormSelect,
    AppButton,
    CustomIcons,
    InstitutionScheduleTable,
    InstitutionDoctors
  },
  data() {
    return {
      selectedUnit: "",
      selectedUnitSpecialty: "",
      selectedDoctor: {},
      selectedScheduleSlot: {}
    };
  },
  methods: {
    async getInstitutionUnitSpecialties() {
      await this.$store.dispatch(
        "institutions/fetchInstitutionUnitSpecialties",
        this.selectedUnit
      );
    },
    openDoctorsModal() {
      this.$bvModal.show("doctorsModal");
    },
    closeDoctorsModal() {
      this.$bvModal.hide("doctorsModal");
    },
    selectScheduleDoctor(doctor) {
      this.selectedDoctor = doctor;
      this.$bvModal.hide("doctorsModal");
    },
    selectScheduleSlot(slot) {
      this.selectedScheduleSlot = slot;
    },
    schedule(hour, date, id) {
      this.$store.dispatch("appointments/holdScheduleAppointment", {
        scheduled_at: `${date} ${hour}:00`,
        scheduled_until: `${date} 00:00:00`,
        doctor: this.selectedDoctor,
        slot_date: date,
        slot_hour: hour,
        slot_id: id
      });
      this.$router.push({ name: "Schedule" });
    }
  },
  computed: {
    unitsOptions() {
      return this.$store.getters["institutions/unitsOptions"];
    },
    unitSpecialtiesOptions() {
      return this.$store.getters["institutions/unitSpecialtiesOptions"];
    },
    isDoctorSelectButtonDisabled() {
      if (this.selectedUnit.length && this.selectedUnitSpecialty.length) {
        return false;
      } else {
        return true;
      }
    },
    iconColor() {
      return this.isDoctorSelectButtonDisabled ? "#f1f3f5" : "#343a40";
    },
    isButtonDisabled() {
      return (
        this.selectedUnit &&
        this.selectedUnitSpecialty &&
        this.selectedDoctor.id &&
        this.selectedScheduleSlot.slot_id
      );
    }
  },
  watch: {
    selectedUnit(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getInstitutionUnitSpecialties();
      }
    }
  }
};
</script>
